/**
 * TelaFim.ts — Overlay de fim de partida (vitoria/derrota + ranking + acoes).
 *
 * Refator de tres.php:1614-1691.
 */

import gsap from 'gsap';
import { corHex } from '../config';
import type { EstadoJogo } from '../domain/tipos';
import type { MsgPartidaFim } from '../ws/protocolo';

const MOTIVOS: Record<string, string> = {
  vitoria_dominante: 'Dominacao do mapa',
  eliminacao_total:  'Eliminacao total dos oponentes',
  timeout:           'Tempo esgotado: vence quem tem mais planetas',
  abandono:          'Partida abandonada',
};

export class TelaFim {
  private readonly elOverlay: HTMLElement;
  private readonly elCard: HTMLElement;
  private readonly elTitulo: HTMLElement;
  private readonly elMotivo: HTMLElement;
  private readonly elDuracao: HTMLElement;
  private readonly elJogadores: HTMLElement;
  private readonly elRanking: HTMLElement;
  private readonly elJogarNovamente: HTMLButtonElement;

  constructor(private readonly estado: EstadoJogo) {
    this.elOverlay = obrigatorio('swFim');
    this.elCard = obrigatorio('swFimCard');
    this.elTitulo = obrigatorio('swFimTitulo');
    this.elMotivo = obrigatorio('swFimMotivo');
    this.elDuracao = obrigatorio('swFimDuracao');
    this.elJogadores = obrigatorio('swFimJogadores');
    this.elRanking = obrigatorio('swFimRanking');
    this.elJogarNovamente = obrigatorio('swFimJogarNovamente') as HTMLButtonElement;

    this.elJogarNovamente.addEventListener('click', () => window.location.reload());
  }

  mostrar(msg: MsgPartidaFim): void {
    const venceu = msg.vencedor_id !== null && msg.vencedor_id === this.estado.meuId;
    const slotVencedor = msg.vencedor_slot || 0;
    const corVencedor = slotVencedor > 0 ? corHex(slotVencedor) : '#64748b';

    // Titulo
    if (venceu) {
      this.elTitulo.textContent = 'VITORIA!';
      this.elTitulo.classList.remove('derrota');
    } else if (msg.vencedor_id !== null) {
      this.elTitulo.textContent = 'DERROTA';
      this.elTitulo.classList.add('derrota');
    } else {
      this.elTitulo.textContent = 'FIM DE PARTIDA';
      this.elTitulo.classList.remove('derrota');
    }

    this.elMotivo.textContent = MOTIVOS[msg.motivo] || msg.motivo;

    const s = msg.duracao_segundos || 0;
    const mins = Math.floor(s / 60);
    const secs = s % 60;
    this.elDuracao.textContent = `${mins}:${secs < 10 ? '0' + secs : secs}`;
    this.elJogadores.textContent = String(msg.ranking?.length || 0);

    this.elCard.style.setProperty('--sw-cor-jogador', corVencedor);

    // Ranking
    this.elRanking.innerHTML = '';
    if (msg.ranking) {
      for (const r of msg.ranking) {
        const li = document.createElement('li');
        li.className = `sw-fim-rank-item${r.posicao === 1 ? ' vencedor' : ''}`;
        li.style.setProperty('--rank-cor', corHex(r.slot_cor));
        li.innerHTML = `
          <span class="sw-fim-rank-pos">${r.posicao}</span>
          <span class="sw-fim-rank-cor"></span>
          <span class="sw-fim-rank-nome">${escapeHtml(r.nome)}</span>
          <span class="sw-fim-rank-detalhe">${r.planetas} planetas · ${r.naves_no_fim} naves</span>
        `;
        this.elRanking.appendChild(li);
      }
    }

    this.elOverlay.classList.add('visivel');
    gsap.fromTo(
      this.elCard,
      { y: 30, opacity: 0, scale: 0.95 },
      { y: 0, opacity: 1, scale: 1, duration: 0.55, ease: 'power2.out' },
    );
  }
}

function obrigatorio(id: string): HTMLElement {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Elemento #${id} nao encontrado no DOM`);
  return el;
}

function escapeHtml(s: string): string {
  return String(s ?? '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[c] || c);
}
